import * as React from "react";
import { SVGProps } from "react";
const SvgPowerOutage2 = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12.51 17.373a.448.448 0 0 1-.26-.087.58.58 0 0 1-.188-.235.72.72 0 0 1 .02-.627l4.455-8.216a.4.4 0 0 1 .204-.187.322.322 0 0 1 .256.011c.082.04.15.11.193.203.043.093.058.2.043.304l-.843 5.748h3.1c.094 0 .185.03.265.09.08.058.145.142.188.242a.72.72 0 0 1-.037.636l-5.034 8.55a.39.39 0 0 1-.216.18.324.324 0 0 1-.26-.03.431.431 0 0 1-.184-.224.547.547 0 0 1-.021-.314l1.395-6.045h-3.075v.001Z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M15.905 2C23.677 2 30 8.28 30 16s-6.323 14-14.095 14S1.809 23.72 1.809 16c0-2.636.734-5.171 2.104-7.366-.454.136-.933.295-1.467.483-.271.096-.57.08-.83-.044a1.07 1.07 0 0 1-.51-1.437c.124-.257.346-.456.618-.55 1.45-.508 2.804-.944 4.714-1.135h.024l.01-.002-.034.002c.072-.007.143-.007.215 0l.039.007a1.084 1.084 0 0 1 .905.802l.008.034c.406 1.86.409 3.274.37 4.801-.008.281-.125.548-.328.744a1.09 1.09 0 0 1-.757.306h-.026a1.092 1.092 0 0 1-.76-.334 1.076 1.076 0 0 1-.298-.77 28.13 28.13 0 0 0-.001-1.843A11.716 11.716 0 0 0 3.978 16c0 6.532 5.35 11.846 11.927 11.846 6.576 0 11.926-5.314 11.926-11.846S22.481 4.154 15.905 4.154c-1.69 0-3.321.343-4.852 1.02A1.088 1.088 0 0 1 9.62 4.63a1.069 1.069 0 0 1 .55-1.422A14.074 14.074 0 0 1 15.904 2Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgPowerOutage2;
